import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Wrap any page that requires Restaurant Core capability.
 * - Platform users (no tenant) get redirected to /tenants
 * - Tenants without restaurant_core or combo_integration see a friendly notice.
 */
export default function RestaurantModuleGuard({ children }) {
  const { t } = useTranslation();
  const { user, tenant, checking } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!checking && user && !tenant) {
      // Platform users don't have restaurant context — send them to tenants.
      navigate("/tenants", { replace: true });
    }
  }, [checking, user, tenant, navigate]);

  if (checking) {
    return (
      <div className="surface-card p-12 text-center text-[#475569]" data-testid="rmg-loading">
        {t("restaurant.common.loading")}
      </div>
    );
  }

  const enabled = tenant?.enabled_modules || [];
  const hasAccess =
    enabled.includes("restaurant_core") || enabled.includes("combo_integration");

  if (!hasAccess) {
    return (
      <div
        className="surface-card p-12 text-center text-[#475569]"
        data-testid="rmg-blocked"
      >
        {t("restaurant.common.module_required")}
      </div>
    );
  }

  return children;
}
